import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/uni-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-431c6554"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing" }
const _hoisted_2 = { class: "header__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header__logo",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "header__navigation" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Welcome = _resolveComponent("Welcome")!
  const _component_AboutUs = _resolveComponent("AboutUs")!
  const _component_PreparationDirections = _resolveComponent("PreparationDirections")!
  const _component_Futher = _resolveComponent("Futher")!
  const _component_Alumnuses = _resolveComponent("Alumnuses")!
  const _component_Call = _resolveComponent("Call")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header__close-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isHeader = !_ctx.isHeader))
    }, _toDisplayString(_ctx.isHeader ? '🗙' : '☰'), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["landing__header header", _ctx.isHeader ? 'landing__header--opened' : 'landing__header--closed'])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationItems, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              class: "header__navigation-item",
              key: item.goTo,
              href: `#${item.goTo}`
            }, _toDisplayString(item.name), 9, _hoisted_5))
          }), 128))
        ])
      ])
    ], 2),
    _createVNode(_component_Welcome),
    _createVNode(_component_AboutUs, {
      class: "landing__about-us",
      id: "about-us"
    }),
    _createVNode(_component_PreparationDirections, {
      class: "landing__preparation-directions",
      id: "directions"
    }),
    _createVNode(_component_Futher),
    _createVNode(_component_Alumnuses, { id: "alumnuses" }),
    _createVNode(_component_Call),
    _createVNode(_component_Footer, { id: "contacts" })
  ]))
}